/**
 * This function returns an API format object for collapsed rows.
 * A false value for isModalOpened would be assigned for the main grid,
 * and a true value for the modal grid.
 *
 * @param {boolean} isModalOpened - Indicates whether the modal is opened or not.
 * @returns {object} - The API format object for collapsed rows.
 */
export function collapsedRowApiFormat(isModalOpened) {
  const result = {
    ExpandCollapsedRows: isModalOpened,
    CollapseCondition: {
      Filter: {
        LogicalOperator: 'OR',
        Expressions: [
          {
            '@odata.type': '#Model.Predicate',
            PropertyName: 'Spend',
            Operator: 'Equals',
            Values: [
              '0',
            ],
          },
        ],
      },
    },
  };

  return result;
}
